import React from 'react';

const TermsAndConditions: React.FC = () => (
  <div style={{ maxWidth: 800, margin: '40px auto', padding: '24px', fontFamily: 'serif', color: '#222' }}>
    <h1>Terms and Conditions</h1>
    <p>Last updated: June 2025</p>

    <h2>1. Acceptance of Terms</h2>
    <p>Access to and use of the StudyMind platform (the "Service") is subject to the following terms and conditions. By accessing or using the Service, acceptance of these terms and conditions is deemed to have occurred. If these terms and conditions are not accepted, use of the Service is strictly prohibited.</p>

    <h2>2. Data Protection and Privacy</h2>
    <ul>
      <li>Personal data and uploaded content shall not be disclosed to third parties without the explicit consent of the data subject, except as required by applicable law or legal process.</li>
      <li>All data shall be processed and stored in accordance with relevant data protection legislation and best practices for information security.</li>
    </ul>

    <h2>3. Credit System and Refund Policy</h2>
    <ul>
      <li>Actions performed within the Service may require the expenditure of credits. Credits are non-refundable except in cases of system error or credit conflict, as determined and approved by StudyMind administration.</li>
      <li>In the event of an approved credit conflict, only credits shall be refunded. No monetary refunds shall be issued under any circumstances.</li>
      <li>Credits possess no cash value and are not redeemable for currency or any form of monetary compensation.</li>
    </ul>

    <h2>4. User Content and Responsibility</h2>
    <ul>
      <li>All content uploaded to the Service must be intended solely for study and educational purposes.</li>
      <li>All content generated by the Service, including but not limited to flashcards, study materials, and AI-generated responses, is intended solely for study and educational purposes. Users acknowledge that any use of such generated content for cheating, plagiarism, or other academic misconduct is strictly prohibited, and users shall bear full responsibility for any such misuse.</li>
      <li>Content containing personal data, confidential information, or material that is illegal, offensive, or infringes upon the rights of any third party is strictly prohibited.</li>
      <li>Responsibility for any content uploaded rests solely with the uploading party. In the event that uploaded content is found to be illegal or in violation of these terms, the uploading party shall bear full legal responsibility for any resulting consequences.</li>
    </ul>

    <h2>5. Intellectual Property</h2>
    <ul>
      <li>All intellectual property rights in the Service, including but not limited to software, content, and trademarks, are the exclusive property of StudyMind or its licensors.</li>
      <li>No part of the Service may be copied, modified, distributed, or used to create derivative works without the prior written consent of StudyMind.</li>
    </ul>

    <h2>6. Service Availability</h2>
    <ul>
      <li>No guarantee is made regarding the uninterrupted availability or continued operation of the Service. The Service may be suspended or discontinued at any time without notice.</li>
      <li>StudyMind shall not be liable for any loss or damage arising from interruptions, suspensions, or discontinuation of the Service, or from any loss of data.</li>
    </ul>

    <h2>7. Limitation of Liability</h2>
    <ul>
      <li>To the maximum extent permitted by law, StudyMind and its affiliates shall not be liable for any indirect, incidental, special, exemplary, or consequential damages arising out of or in connection with the use or inability to use the Service.</li>
      <li>Use of the Service is undertaken at the sole risk of the user.</li>
    </ul>

    <h2>8. Amendments</h2>
    <ul>
      <li>These terms and conditions may be amended, modified, or updated at any time at the sole discretion of StudyMind. Continued use of the Service following any such amendment shall constitute acceptance of the revised terms and conditions.</li>
    </ul>

    <h2>9. Governing Law</h2>
    <ul>
      <li>These terms and conditions shall be governed by and construed in accordance with the laws of the jurisdiction in which StudyMind operates, without regard to conflict of law principles.</li>
    </ul>

    <h2>10. Contact</h2>
    <p>All inquiries regarding these terms and conditions shall be directed to: <a href="mailto:admin@study-mind.com">admin@study-mind.com</a>.</p>
    
    <h2>11. Company Information</h2>
    <p>StudyMind is owned and operated by ALGO-5 Limited. All rights, title, and interest in and to the Service, including all intellectual property rights, are and will remain the exclusive property of ALGO-5 Limited.</p>
  </div>
);

export default TermsAndConditions; 